// src/pages/TestEdit.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";
import Select from "react-select";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SingleImageDropzone } from "../DropzoneComponents";

export default function TestEdit() {
  const { id } = useParams();
  const nav = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

  const [form, setForm] = useState({
    name: "",
    max_score: "",
    description: "",
    price: "",
    categoryType: "0",
    hasSelection: false,
    isPopular: false,
    showOnHome: false,
    image: null,
    preview: null,
    type_ids: [],
    couponId: null,
      hasFeaturedCategory: false, //  yeni
  questionCounter: 1,
  isFullyPaid: false,
  hasDualMainResult: false,
  hasDualCategoryResult: false   
  });

  // --- karşılıklı dışlama yardımcıları ---
const disableHasSelection          = form.hasFeaturedCategory || form.hasDualCategoryResult || form.hasDualMainResult;
const disableHasFeaturedCategory   = form.hasSelection        || form.hasDualCategoryResult || form.hasDualMainResult;
const disableHasDualCategoryResult = form.hasSelection        || form.hasFeaturedCategory   || form.hasDualMainResult;
const disableHasDualMainResult     = form.hasSelection        || form.hasFeaturedCategory   || form.hasDualCategoryResult;

// İkili Ana Sonuç seçiliyse kategori tipi ve “Seçim Olsun mu?” da kilitlenecek
const categoryTypeDisabled = form.hasDualMainResult;


  const [loading, setLoading] = useState(false);
  const [testTypeOptions, setTestTypeOptions] = useState([]); // select seçenekleri
const [couponOptions, setCouponOptions] = useState([]);
  /* i18n */
  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (k, d = "") => translations[k] || d;

  // 📌 Test türlerini çek
  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const { data } = await axios.get(`${API_BASE}/api/test-types`, {
          headers: { Authorization: `Bearer ${token}` }
        });
         setTestTypeOptions(
   data.map(tt => ({ value: Number(tt.id), label: tt.name }))
 );
      } catch (err) {
        console.error("Test türleri çekilemedi:", err);
      }
    })();
  }, [API_BASE]);

  // kuponları (aktif + tarihi uygun) çek
useEffect(() => {
  (async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const { data } = await axios.get(
        `${API_BASE}/api/coupons?active=1&valid=1`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const opts = (data || []).map(c => ({
        value: c.id,
        label: c.discount_type === "percent"
          ? `${c.code} — %${c.discount_value}`
          : `${c.code} — ${Number(c.discount_value).toLocaleString("tr-TR",{minimumFractionDigits:2, maximumFractionDigits:2})} ₺`,
      }));
      setCouponOptions(opts);
    } catch (err) {
      console.error("❌ Kupon listesi alınamadı:", err);
    }
  })();
}, [API_BASE]);


  // 📌 Mevcut test verisini çek
  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const { data } = await axios.get(
          `${API_BASE}/api/tests/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        let catType = "0";
        if (data.has_category) {
          catType = data.multiple_category ? "2" : "1";
        }

        setForm(prev => ({
          ...prev,
          name: data.name,
          max_score: data.max_score,
          description: data.description || "",
          price: data.price ?? "",
          categoryType: catType,
          isPopular: Boolean(data.is_popular),
          hasSelection: Boolean(data.has_selection),
          showOnHome: Boolean(data.show_on_home),
          isFullyPaid: Boolean(data.is_fully_paid), 
          image: null,
          hasDualCategoryResult: Boolean(data.has_dual_category_result),
          hasDualMainResult: Boolean(data.has_dual_main_result),
            hasFeaturedCategory: Boolean(data.has_featured_category),
            couponId: data.coupon_id ?? data.coupon?.id ?? null,
  questionCounter: data.question_counter ?? 1,     
          preview: data.image ? `${API_BASE}${data.image}` : null,
          type_ids: Array.isArray(data.test_types ?? data.TestTypes)
          
   ? (data.test_types ?? data.TestTypes).map(tt => Number(tt.id))
   : []
        }));
      } catch (e) {
        console.error("Test veri çekme hatası:", e);
      }
    })();
  }, [id, API_BASE]);

  // 📌 input değişimleri
  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

// Kategori tipi (İkili Ana Sonuç varken değiştirilmesin)
const handleSelectChange = (e) => {
  if (form.hasDualMainResult) return;
  setForm(prev => ({ ...prev, categoryType: e.target.value }));
};

// Seçim Olsun Mu?
const handleCheckboxChange = (e) => {
  const checked = e.target.checked;
  setForm(prev => ({
    ...prev,
    hasSelection: checked,
    ...(checked ? {
      hasFeaturedCategory: false,
      hasDualCategoryResult: false,
      hasDualMainResult: false,
    } : {})
  }));
};

// Tek kategoriye göre sonuç
const handleFeaturedChange = (e) => {
  const checked = e.target.checked;
  setForm(prev => ({
    ...prev,
    hasFeaturedCategory: checked,
    ...(checked ? {
      hasSelection: false,
      hasDualCategoryResult: false,
      hasDualMainResult: false,
    } : {})
  }));
};

// İki kategoriye göre sonuç
const handleDualCategoryChange = (e) => {
  const checked = e.target.checked;
  setForm(prev => ({
    ...prev,
    hasDualCategoryResult: checked,
    ...(checked ? {
      hasSelection: false,
      hasFeaturedCategory: false,
      hasDualMainResult: false,
    } : {})
  }));
};

// İkili Ana Sonuç Sayfası
const handleDualMainResultChange = (e) => {
  const checked = e.target.checked;
  setForm(prev => ({
    ...prev,
    hasDualMainResult: checked,
    // Seçildiyse kategori tamamen yok + diğerleri kapanır
    ...(checked ? {
      categoryType: "0",
      hasSelection: false,
      hasFeaturedCategory: false,
      hasDualCategoryResult: false,
    } : {})
  }));
};


  const handlePopularChange = e => {
    setForm(prev => ({ ...prev, isPopular: e.target.checked }));
  };

  const handleImageChange = file =>
    setForm(prev => ({
      ...prev,
      image: file,
      preview: URL.createObjectURL(file)
    }));

  const handleRemoveImage = () =>
    setForm(prev => ({ ...prev, image: null, preview: null }));

  // 📌 Test Type seçimi
  const handleTestTypeChange = selected => {
    setForm(prev => ({
      ...prev,
      type_ids: selected ? selected.map(opt => opt.value) : []
    }));
  };
  const handleShowOnHomeChange = e => {
  setForm(prev => ({ ...prev, showOnHome: e.target.checked }));
};

  // 📌 Submit
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);

    try {
      const fd = new FormData();
      fd.append("name", form.name.trim());
      fd.append("max_score", Number(form.max_score));
      fd.append("description", form.description.trim());
fd.append("is_fully_paid", form.isFullyPaid ? 1 : 0); // 🆕
fd.append("has_dual_main_result", form.hasDualMainResult ? 1 : 0);
      const ct = Number(form.categoryType);
      fd.append("has_category", ct > 0 ? 1 : 0);
      fd.append("multiple_category", ct === 2 ? 1 : 0);
      fd.append("has_selection", form.hasSelection ? 1 : 0);
      fd.append("is_popular", form.isPopular ? 1 : 0);
      fd.append("price", parseFloat(form.price) || 0);
      fd.append("show_on_home", form.showOnHome ? 1 : 0);
      fd.append("has_featured_category", form.hasFeaturedCategory ? 1 : 0);
fd.append("question_counter", form.questionCounter || 1);
fd.append("has_dual_category_result", form.hasDualCategoryResult ? 1 : 0);
if (form.couponId) {
  fd.append("coupon_id", form.couponId);
} else {
  // kupon kaldırıldıysa backende null iletmek istiyorsan:
  fd.append("coupon_id", "");
}
      if (form.image instanceof File) {
        fd.append("image", form.image);
      }

      // 📌 type_ids[] olarak ekle
     fd.append("type_ids", JSON.stringify(form.type_ids)); // [] olsa bile gider

      const token = localStorage.getItem("admin_token");
      await axios.put(`${API_BASE}/api/tests/${id}`, fd, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success("Kayıt başarıyla güncellendi!");
      setTimeout(() => nav(`/test/table`), 1000);
    } catch (err) {
      console.error("Güncelleme hatası:", err);
      toast.error(t("UPDATE_FAILED", "Güncelleme başarısız"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container my-4">
      <ToastContainer />
      <div className="card shadow-sm">
        <div className="card-header">
          <h5 className="mb-0">{t("EDIT_TEST", "Test Düzenle")}</h5>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="card-body">

            {/* Test Adı */}
            <div className="mb-3">
              <label className="form-label fw-semibold">
                {t("TABLE_TEST_NAME", "Test Adı")}
              </label>
              <input
                name="name"
                className="form-control"
                value={form.name}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </div>
            
            {/* Test Type (MultiSelect) */}
            <div className="mb-3">
              <label className="form-label fw-semibold">
                {t("TEST_TYPES", "Test Türleri")}
              </label>
              <Select
                isMulti
                options={testTypeOptions}
                value={testTypeOptions.filter(opt =>
                  form.type_ids.includes(opt.value)
                )}
                onChange={handleTestTypeChange}
                isClearable
                isDisabled={loading}
                placeholder="Tür seçin (zorunlu değil)"
              />
            </div>

            {/* Maks. Puan */}
            <div className="mb-3">
              <label className="form-label fw-semibold">
                {t("TABLE_MAX_SCORE", "Maks. Puan")}
              </label>
              <input
                name="max_score"
                type="number"
                min={0}
                className="form-control"
                value={form.max_score}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </div>

            {/* Açıklama */}
            <div className="mb-3">
              <label className="form-label fw-semibold">
                {t("DESCRIPTION", "Açıklama")}
              </label>
              <textarea
                name="description"
                className="form-control"
                rows={3}
                value={form.description}
                onChange={handleChange}
                disabled={loading}
              />
            </div>
              <div className="mb-3">
    <label className="form-label fw-semibold">
      Sayfada gösterilecek soru sayısı
    </label>
    <input
      type="number"
      className="form-control"
      value={form.questionCounter}
      onChange={e =>
        setForm(prev => ({ ...prev, questionCounter: e.target.value }))
      }
      min={1}
      step={1}
      placeholder="Örn. 10"
      disabled={loading}
    />
  </div>

              {/* Fiyat */}
            <div className="mb-3">
              <label className="form-label fw-semibold">
                {t("PRICE", "Fiyat")}
              </label>
              <input
                name="price"
                type="number"
                step="0.01"
                min="0"
                className="form-control"
                value={form.price}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </div>

            {/* Kategori Tipi */}
            <div className="mb-3">
              <label className="form-label fw-semibold">
                {t("CATEGORY_TYPE", "Kategori Tipi")}
              </label>
              <select
                className="form-select"
                value={form.categoryType}
  onChange={handleSelectChange}
  disabled={loading || categoryTypeDisabled}
              >
                <option value="0">{t("NO_CATEGORY", "Kategori yok")}</option>
                <option value="1">{t("SINGLE_CATEGORY", "Tekli seçim")}</option>
                <option value="2">{t("MULTIPLE_CATEGORY", "Çoklu seçim")}</option>
              </select>
            </div>
                        {/* Popüler */}
            <div className="form-check mb-3">
              <input
                type="checkbox"
                id="isPopular"
                className="form-check-input"
                checked={form.isPopular}
                onChange={handlePopularChange}
                disabled={loading}
              />
              <label className="form-check-label" htmlFor="isPopular">
                {t("IS_POPULAR", "Popüler Test Olsun Mu?")}
              </label>
            </div>
          {/*Anasayfada Görünsün mü? */} 
        <div className="form-check mb-3">
          <input
            type="checkbox"
            id="showOnHome"
            className="form-check-input"
            checked={form.showOnHome}
            onChange={handleShowOnHomeChange}
            disabled={loading}
          />
          <label className="form-check-label" htmlFor="showOnHome">
            {t("SHOW_ON_HOME", "Anasayfada Görünsün mü?")}
          </label>
        </div>
        {/* Tamamen Ücretli mi? */}
<div className="form-check mb-3">
  <input
    type="checkbox"
    id="isFullyPaid"
    className="form-check-input"
    checked={form.isFullyPaid}
    onChange={e => setForm(prev => ({ ...prev, isFullyPaid: e.target.checked }))}
    disabled={loading}
  />
  <label className="form-check-label" htmlFor="isFullyPaid">
    Tamamen Ücretli mi? (Ödeme yapıldıktan sonra test çözülebilir)
  </label>
</div>

            {/* Seçim Olsun Mu? */}
            <div className="form-check mb-3">
              <input
                type="checkbox"
                id="hasSelection"
                className="form-check-input"
                checked={form.hasSelection}
                onChange={handleCheckboxChange}
  disabled={loading || disableHasSelection}
              />
              <label className="form-check-label" htmlFor="hasSelection">
                {t("HAS_SELECTION", "Seçim Olsun Mu? (İlk başta kategori seçtirecek miyiz?)")}
              </label>
            </div>


        {/* Tek Kategoriye Göre Sonuç */}
<div className="form-check mb-3">
  <input
    type="checkbox"
    id="hasFeaturedCategory"
    className="form-check-input"
    checked={form.hasFeaturedCategory}
    onChange={e => {
      const checked = e.target.checked;
      setForm(prev => ({
        ...prev,
        hasFeaturedCategory: checked,
        questionCounter: checked ? prev.questionCounter : 1
      }));
    }}
      disabled={loading || disableHasFeaturedCategory}
  />
  <label className="form-check-label" htmlFor="hasFeaturedCategory">
    Tek bir kategoriye göre sonuç çıksın mı? (En çok puan alan kategorinin sonucuna göre)
  </label>
</div>

{/* İki Kategoriye Göre Sonuç */}
<div className="form-check mb-3">
  <input
    type="checkbox"
    id="hasDualCategoryResult"
    className="form-check-input"
    checked={form.hasDualCategoryResult}
    onChange={e =>
      setForm(prev => ({ ...prev, hasDualCategoryResult: e.target.checked }))
    }
    disabled={loading || disableHasDualCategoryResult}
  />
  <label className="form-check-label" htmlFor="hasDualCategoryResult">
    İki kategoriye göre sonuç çıksın mı? (En çok puan alan iki kategorinin sonucuna göre)
  </label>
</div>




{/* İkili Ana Sonuç Sayfası */}

<div className="form-check mb-3">
  <input
    type="checkbox"
    id="hasDualMainResult"
    className="form-check-input"
    checked={form.hasDualMainResult}
    onChange={e => setForm(prev => ({ ...prev, hasDualMainResult: e.target.checked }))}
    disabled={loading || disableHasDualMainResult}
  />
  <label className="form-check-label" htmlFor="hasDualMainResult">
    İkili Ana Sonuç Sayfası Kullanılsın mı? (Ana editör, Yan editör) Bu şık tercih edildiği zaman kategori tercihi yapmayınız.
  </label>
</div>







            {/* Resim */}
            <div className="mb-3">
              <label className="form-label fw-semibold">
                {t("IMAGE", "Resim")}
              </label>
              <SingleImageDropzone
                fieldName="image"
                fieldValue={form.preview || form.image}
                setFieldValues={() => {}}
                onChange={handleImageChange}
                onRemove={handleRemoveImage}
                maxWidth={800}
                maxHeight={600}
                disabled={loading}
                required={false}
              />
            </div>
          </div>

          <div className="d-flex justify-content-center mb-3">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? t("LOADING", "Kaydediliyor…") : t("SAVE", "Kaydet")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
